import {
  IProjectProfiles,
  IProjectStatusesEnum,
  IUnviewedItems,
  IWeather,
} from '_interfaces/types/project.types';
import { DocumentData } from 'firebase/firestore';
import { LagTypeEnum } from 'redux-store/api/company';
import { IPhase } from 'redux-store/types';

export class IProject {
  static kId = 'id';
  static kType = 'type';
  static kName = 'name';
  static kSubDivision = 'subDivision';
  static kLot = 'lot';
  static kAddress = 'address';
  static kSecondAddress = 'secondAddress';
  static kCity = 'city';
  static kState = 'state';
  static kStateAbbr = 'stateAbbr';
  static kZip = 'zip';
  static kCountry = 'country';
  static kLat = 'lat';
  static kLng = 'lng';
  static kStatus = 'status';
  static kImage = 'image';
  static kStartDate = 'startDate';
  static kCreatedAt = 'createdAt';
  static kCanBeEmpty = 'canBeEmpty';
  static kTz = 'tz';
  static kActivityCount = 'activityCount';
  static kLastUpdatedAt = 'lastUpdatedAt';
  static kUnviewedItemCounts = 'unviewedItemCounts';
  static kWeather = 'weather';
  static kPhases = 'phases';
  static kProfiles = 'profiles';
  static kTemplateId = 'templateId';
  static kFolderId = 'folderId';
  static kLagType = 'lagType';
  static kWorkingDays = 'workingDays';

  constructor(
    public readonly id: number,
    public readonly type: string,
    public readonly name: string,
    public readonly subDivision: string | null,
    public readonly lot: string | null,
    public readonly address: string,
    public readonly secondAddress: string | null,
    public readonly city: string,
    public readonly state: string,
    public readonly stateAbbr: string,
    public readonly zip: string,
    public readonly country: string,
    public readonly lat: number | string,
    public readonly lng: number | string,
    public readonly status: IProjectStatusesEnum,
    public readonly image: string | null,
    public readonly startDate: string | null,
    public readonly createdAt: string | null,
    public readonly canBeEmpty: boolean,
    public readonly tz: string,
    public readonly activityCount: number,
    public readonly lastUpdatedAt: string,
    public readonly unviewedItemCounts: IUnviewedItems,
    public readonly weather: IWeather | null,
    public readonly phases: IPhase[],
    public readonly profiles: IProjectProfiles[],
    public readonly lagType: LagTypeEnum,
    public readonly templateId?: string | number,
    public readonly folderId?: string | number,
    public readonly workingDays?: number[]
  ) {}

  static empty() {
    return new IProject(
      0,
      '',
      '',
      null,
      null,
      '',
      null,
      '',
      '',
      '',
      '',
      '',
      0,
      0,
      IProjectStatusesEnum.ACTIVE,
      null,
      null,
      null,
      false,
      '',
      0,
      '',
      {
        notifications: 0,
        posts: 0,
        messages: 0,
      },
      null,
      [],
      [],
      LagTypeEnum.MAINTAIN,
      undefined,
      undefined,
      undefined
    );
  }

  static fromReduxData(data: any) {
    return new IProject(
      data.id || 0,
      data.type || '',
      data.name || '',
      data.subDivision || null,
      data.lot || null,
      data.address || '',
      data.secondAddress || null,
      data.city || '',
      data.state || '',
      data.stateAbbr || '',
      data.zip || '',
      data.country || '',
      data.lat || 0,
      data.lng || 0,
      data.status || IProjectStatusesEnum.ACTIVE,
      data.image || null,
      data.startDate || null,
      data.createdAt || null,
      data.canBeEmpty || false,
      data.tz || '',
      data.activityCount || 0,
      data.lastUpdatedAt || '',
      data.unviewedItemCounts || {
        notifications: 0,
        posts: 0,
        messages: 0,
      },
      data.weather || null,
      data.phases || [],
      data.profiles || [],
      data.lagType || LagTypeEnum.MAINTAIN,
      data.templateId,
      data.folderId,
      data.workingDays
    );
  }

  static fromDocumentData(data: DocumentData) {
    return new IProject(
      data[IProject.kId] || 0,
      data[IProject.kType] || '',
      data[IProject.kName] || '',
      data[IProject.kSubDivision] || null,
      data[IProject.kLot] || null,
      data[IProject.kAddress] || '',
      data[IProject.kSecondAddress] || null,
      data[IProject.kCity] || '',
      data[IProject.kState] || '',
      data[IProject.kStateAbbr] || '',
      data[IProject.kZip] || '',
      data[IProject.kCountry] || '',
      data[IProject.kLat] || 0,
      data[IProject.kLng] || 0,
      data[IProject.kStatus] || IProjectStatusesEnum.ACTIVE,
      data[IProject.kImage] || null,
      data[IProject.kStartDate] || null,
      data[IProject.kCreatedAt] || null,
      data[IProject.kCanBeEmpty] || false,
      data[IProject.kTz] || '',
      data[IProject.kActivityCount] || 0,
      data[IProject.kLastUpdatedAt] || '',
      data[IProject.kUnviewedItemCounts] || {
        notifications: 0,
        posts: 0,
        messages: 0,
      },
      data[IProject.kWeather] || null,
      data[IProject.kPhases] || [],
      data[IProject.kProfiles] || [],
      data[IProject.kLagType] || LagTypeEnum.MAINTAIN,
      data[IProject.kTemplateId],
      data[IProject.kFolderId],
      data[IProject.kWorkingDays]
    );
  }
}
